import { IElement } from "core-integration/src/store/elements/types";
import { ITeam } from "core-integration/src/store/teams/types";
import { ellipsis } from "polished";
import * as React from "react";
import styled from "styled-components";
import ElementShirt from "./ElementShirt";
import Media from "./Media";

const MenuButton = styled.button`
  ${ellipsis()};
  width: 100%;
  padding: 0;
  border: 0;
  background-color: transparent;
  color: inherit;
  font-family: ${({ theme }) => theme.fonts.base};
  font-weight: bold;
  text-align: left;
  cursor: pointer;
`;

const Name = styled.div`
  ${ellipsis()};
  color: ${({ theme }) => theme.colors.white};
  font-weight: bold;

  :hover {
    text-decoration: underline;
  }
`;

const Team = styled.div`
  margin-right: ${({ theme }) => theme.space[2]};
  color: ${({ theme }) => theme.colors.white};
  font-size: ${({ theme }) => theme.fontSizes[1]};
  font-weight: normal;
`;

interface IOwnProps {
  element: IElement;
  renderElementMenu: () => void;
  team: ITeam;
}

type Props = IOwnProps;

const ElementInTable: React.FC<Props> = ({
  element,
  renderElementMenu,
  team,
}) => {
  const Shirt = <ElementShirt elementId={element.id} sizes="24px" />;
  return (
    <MenuButton onClick={renderElementMenu}>
      <Media img={Shirt} centred={true}>
        <Name>{element.web_name}</Name>
        <Team>{team.short_name}</Team>
      </Media>
    </MenuButton>
  );
};

export default ElementInTable;
